import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthState } from '@core/store/auth/auth.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthInitResolver implements Resolve<boolean> {
  constructor(private store: Store) {}

  resolve(): Observable<boolean> {
    return this.store.select(AuthState.isAuthenticated).pipe(
      filter(isAuthenticated => isAuthenticated !== null && isAuthenticated !== undefined), // wait until auth state is determined
      take(1), // only take once
      map(() => true)
    );
  }
}
